import React from 'react';
import { connect } from 'react-redux';
import { Panel } from 'react-bootstrap';
import update from 'immutability-helper';
import moment from 'moment';
import { actions as toastrActions } from 'react-redux-toastr';
import assign from 'lodash/assign';
import cloneDeep from 'lodash/cloneDeep';
import concat from 'lodash/concat';
import filter from 'lodash/filter';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import flatten from 'lodash/flatten';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import map from 'lodash/map';
import omit from 'lodash/omit';
import orderBy from 'lodash/orderBy';
import pull from 'lodash/pull';
import pullAll from 'lodash/pullAll';
import reduce from 'lodash/reduce';
import remove from 'lodash/remove';
import union from 'lodash/union';
import { toastr } from 'react-redux-toastr';
import { getIsFetching as getIsFetchingRun, getRunById, loadRunForGeneric } from '../../runs/duck';
import {
    assignAbnormalityToMe,
    cancelAbnormality,
    clearErrorMessage,
    closeAbnormality,
    createAbnormality,
    editAbnormality,
    getAbnormalityById,
    getAbnormalityAttachments,
    getError,
    getGenericManifests,
    getIsFetching as getIsFetchingAbnormality,
    getIsFetchingGenericManifests,
    getIsPending as getIsAbnormalityPending,
    isAbnormalityAttachmentsPending,
    loadAbnormality,
    loadAbnormalityFiles,
    loadGenericManifests,
} from '../duck';
import Loader from '../../../components/Loader';
import RouteInfoGeneric from '../components/RouteInfoGeneric';
import ManifestsInfoGeneric from '../components/ManifestsInfoGeneric';
import Comments from '../../../components/Comments/Comments';
import AttachmentsInfo from '../components/AttachmentsInfo';
import GenericInfo from '../components/GenericInfo';
import AbnormalityActionButtons from '../components/AbnormalityActionButtons';
import { ABNORMALITIES, I18N, MANIFEST_BASED, RUN_BASED, STATUSES } from '../../../constants';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { Col, Row } from 'react-bootstrap';
import { handleGenericValidations } from '../../../shared/utils/handleGenericValidations';
import { get, post } from '../../../shared/http/request';
import ReceivedRun from './ReceivedRun';
import {
    abnormalityTypeCanHaveReceivedRun,
    isManifestBased,
} from '../../../shared/utils/abnormalityHelpers';
import RecoveryActionsInfo from '../components/RecoveryActionsInfo';
import {
    createAbnormalityCreationBreadcrumb,
    createAbnormalityDetailBreadcrumb,
} from '../../../shared/utils/breadcrumbs';
import AssigneeInfo from '../../../components/AssigneeInfo';
import TLMSWarning from '../../../components/TLMSWarning';
import Reasons from '../components/Reasons';

const toastrOptions = {
    timeOut: 0,
    icon: <i style={{ margin: 20 }} className="fa fa-spinner fa-pulse fa-2x fa-fw" />,
};

const genericDamageReasons = [
    {
        eventKey: 'Box/stillage damaged',
        label: 'Box/stillage damaged',
    },
    {
        eventKey: 'Dirty freight',
        label: 'Dirty freight',
    },
    {
        eventKey: 'Damage due to strapping',
        label: 'Damage due to strapping',
    },
    {
        eventKey: 'Fallen pallets during handling',
        label: 'Fallen pallets during handling',
    },
    {
        eventKey: 'Fallen pallets during transport',
        label: 'Fallen pallets during transport',
    },
    {
        eventKey: 'Fork hole',
        label: 'Fork hole',
    },
    {
        eventKey: 'Pallet crashed under weight',
        label: 'Pallet crashed under weight',
    },
    {
        eventKey: 'Parts found broken (reason unknown)',
        label: 'Parts found broken (reason unknown)',
    },
    {
        eventKey: 'Parts misplaced in box/stillage',
        label: 'Parts misplaced in box/stillage',
    },
    {
        eventKey: 'Parts spill out',
        label: 'Parts spill out',
    },
    {
        eventKey: 'Potential damage (flagged for inspection)',
        label: 'Potential damage (flagged for inspection)',
    },
    {
        eventKey: 'Rusted parts',
        label: 'Rusted parts',
    },
    {
        eventKey: 'Temporary packaging damaged',
        label: 'Temporary packaging damaged',
    },
    {
        eventKey: 'Wet parts',
        label: 'Wet parts',
    },
    {
        eventKey: 'Other - Specify in the comment box',
        label: 'Other - Specify in the comment box',
    },
];

const genericEarlyFreightReasons = [
    {
        eventKey: 'On request by EMC (internal reasons)',
        label: 'On request by EMC (internal reasons)',
    },
    {
        eventKey: 'Loaded early by mistake',
        label: 'Loaded early by mistake',
    },
    {
        eventKey: 'Containment of other logistics abnormality',
        label: 'Containment of other logistics abnormality',
    },
    {
        eventKey: 'Loaded early to prevent other logistics abnormality',
        label: 'Loaded early to prevent other logistics abnormality',
    },
    {
        eventKey: 'Other - Specify in the comment box',
        label: 'Other - Specify in the comment box',
    },
];

const genericLateFreightReasons = [
    {
        eventKey: 'Missed connection because of delay on previous route',
        label: 'Missed connection because of delay on previous route',
    },
    {
        eventKey: 'Missed connection because of other abnormality on previous route',
        label: 'Missed connection because of other abnormality on previous route',
    },
    {
        eventKey: 'Not loaded on correct route by mistake',
        label: 'Not loaded on correct route by mistake',
    },
    {
        eventKey: 'Other - Specify in the comment box',
        label: 'Other - Specify in the comment box',
    },
];

const genericInternalLogisticsReasons = [
    {
        eventKey: 'On EMC request',
        label: 'On EMC request',
    },
    {
        eventKey: 'Containment of other logistics abnormality',
        label: 'Containment of other logistics abnormality',
    },
    {
        eventKey: 'Other - Specify in the comment box',
        label: 'Other - Specify in the comment box',
    },
];

const genericUnableToLocateReasons = [
    {
        eventKey: 'Part of the manifest is missing',
        label: 'Part of the manifest is missing',
    },
    {
        eventKey: 'Not found at loading',
        label: 'Not found at loading',
    },
    {
        eventKey: 'Not found at unloading',
        label: 'Not found at unloading',
    },
    {
        eventKey: 'Other - Specify in the comment box',
        label: 'Other - Specify in the comment box',
    },
];


class Generic extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                abnManifests: [],
                run: {},
                manifestRoutes: [],
                stops: [],
            },
            errors: {},
            form: {
                abnormalityDate: moment.now(),
                abnormalityLocation: '',
                abnormalityType: '',
                genericAbnormalityType: props.manifestBased ? MANIFEST_BASED : RUN_BASED,
                comment: '',
                runId: null,
                trailerIdentifier: '',
            },
            modalData: {},
            postData: {},
            selectedManifestIds: [],
            selectedKanbanIds: [],
            selectedRoute: '',
            manifestBased: props.manifestBased,
			selectedReason: I18N.FORMS.SELECT_REASON,
            reason:[],
            isReasonToShow : false,
        };
    }

	handleReasonChange = reason => {
        if (this.props.hasError) this.props.clearErrorMessage();
        this.canUpdate = !this.isCancelled && !this.isClosed; 
        let temp = this.state.errors;
        delete temp.reason;
        this.setState({ selectedReason: reason, errors: temp });
    };
	
    componentDidMount() {
        this.getStops();
        this.getAbnormalityData();
    }

    getAbnormalityData() {
        if (this.isAbnormalityCreation()) {
            this.getAbnormalityCreationData();
        } else {
            this.getAbnormalityDetails();
        }
    }

    isAbnormalityCreation() {
        return !this.props.abnormalityId;
    }

    getAbnormalityDetails() {
        // On details screen we look in the response of details call
        // to see if abnormality is manifestBased
        this.props.loadAbnormality(this.props.abnormalityId).then(action => {
            this.getRunsAndManifestData(
                action.abnormality.genericAbnormalityType === MANIFEST_BASED
            );
        });
        this.props.loadAbnormalityFiles(this.props.abnormalityId);
    }

    getAbnormalityCreationData() {
        // On create screen we look in the props
        // to see if abnormality is manifestBased
        this.getRunsAndManifestData(this.props.manifestBased);
    }

    getManifestIdFromStateData() {
        return this.state.data.abnManifests[0].manifest.manifestId;
    }

    getRunsAndManifestData(manifestBased) {
        let { id } = this.props;
        if (!manifestBased) {
            this.props.loadRunForGeneric(id);
        }

        if (!this.isAbnormalityCreation() && manifestBased) {
            id = this.getManifestIdFromStateData();
        }

        this.props.loadGenericManifests(id, manifestBased).then(action => {
            if (manifestBased) {
                this.getRunsForManifest(id);
            }
        });
    }

    getStops() {
        const { id, manifestBased } = this.props;

        if (manifestBased) {
            post(`/api/abnormality/manifests/stops`, {
                manifestIds: [id],
            }).then(
                resp => {
                    const stops = orderBy(
                        concat(resp.fromStops, resp.toStops),
                        ['stopCode'],
                        ['asc']
                    );
                    this.setState(
                        update(this.state, {
                            data: {
                                stops: { $set: stops },
                            },
                        })
                    );
                },
                err => {
                    toastr.error(err.message);
                }
            );
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isAbnormalityPending && nextProps.hasErrors) {
            this.redirectOrRemovePendingToast(false);
        } else if (this.props.isAbnormalityPending && !nextProps.hasErrors) {
            this.redirectOrRemovePendingToast(true);
        }

        const { data } = this.state;

        if (nextProps.abnormalityId !== this.props.abnormalityId) {
            this.getAbnormalityData();
        } else if (
            !!nextProps.abnManifests &&
            !isEqual(nextProps.abnManifests, data.abnManifests)
        ) {
            let manifests = nextProps.abnManifests;
            if (!!nextProps.abnormality) {
                manifests = this.mergeFetchedManifestsWithManifestsInAbnormality(
                    nextProps.abnManifests,
                    nextProps.abnormality.abnormalityManifests
                );
            }
            this.setState(prevState => ({
                data: {
                    ...prevState.data,
                    abnManifests: manifests,
                },
            }));
            if (this.state.manifestBased) {
                this.setState(() => ({
                    selectedManifestIds: map(nextProps.abnManifests, am => am.manifest.manifestId),
                    selectedKanbanIds: flatten(
                        map(nextProps.abnManifests, am => map(am.kanbans, k => k.kanbanId))
                    ),
                }));
            }
        }
        if (nextProps.run && !isEqual(nextProps.run, data.run)) {
            this.setState(prevState => ({
                data: {
                    ...prevState.data,
                    run: nextProps.run,
                },
            }));

            if (!this.props.manifestBased) {
                this.setState(prevState => ({
                    data: {
                        ...prevState.data,
                        stops: orderBy(
                            reduce(
                                nextProps.run.wayPoints,
                                (stops, wp) => stops.concat(wp.stops),
                                []
                            ),
                            ['stopCode'],
                            ['asc']
                        ),
                    },
                }));
            }
        }
        if (nextProps.abnormality && !isEqual(nextProps.abnormality, data.abnormality)) {
            const selectedManifestIds = map(
                nextProps.abnormality.abnormalityManifests,
                am => am.manifest.manifestId
            );
            const selectedKanbanIds = flatten(
                map(nextProps.abnormality.abnormalityManifests, am =>
                    map(am.kanbans, k => k.kanbanId)
                )
            );
            let manifests = nextProps.abnormality.abnormalityManifests;
            if (!!nextProps.abnManifests) {
                manifests = this.mergeFetchedManifestsWithManifestsInAbnormality(
                    nextProps.abnManifests,
                    nextProps.abnormality.abnormalityManifests
                );
            }
			this.handleReasonChangeonInputChange(nextProps.abnormality.abnormalityType);
			if(nextProps.abnormality.reason === null || nextProps.abnormality.reason === ""){
                this.setState ({selectedReason : I18N.FORMS.SELECT_REASON,});
            }
            else{
                this.setState ({selectedReason : nextProps.abnormality.reason,});
            }
            this.setState(prevState => ({
                selectedManifestIds,
                selectedKanbanIds,
                selectedRoute: nextProps.abnormality.runId || '',
                form: {
                    ...prevState.form,
                    abnormalityDate: moment(nextProps.abnormality.abnormalityDate),
                    abnormalityType: nextProps.abnormality.abnormalityType,
                    abnormalityLocation: nextProps.abnormality.stop
                        ? nextProps.abnormality.stop.stopId
                        : I18N.ABNORMALITY_LOCATION.OTHER,
                    comment: nextProps.abnormality.comment,
                    receivedRun: {
                        runId: nextProps.abnormality.receivedRunId,
                        routeCode: nextProps.abnormality.receivedRunRouteCode,
                        runDate: nextProps.abnormality.receivedRunRunDate,
                        runSequence: nextProps.abnormality.receivedRunSequence,
                    },
                    runId: nextProps.abnormality.runId,
                    trailerIdentifier: nextProps.abnormality.trailerIdentifier || '',
                },
                manifestBased: isManifestBased(nextProps.abnormality.genericAbnormalityType),
                data: {
                    ...prevState.data,
                    abnManifests: manifests,
                    run: {
                        ...prevState.data.run,
                        routeCode: nextProps.abnormality.routeCode,
                        runDate: nextProps.abnormality.runDate,
                        runSequence: nextProps.abnormality.runSequence,
                    },
                    receivedRun: {
                        runId: nextProps.abnormality.receivedRunId,
                        routeCode: nextProps.abnormality.receivedRunRouteCode,
                        runDate: nextProps.abnormality.receivedRunRunDate,
                        runSequence: nextProps.abnormality.receivedRunSequence,
                    },
                },
            }));
			
        }
    }

    // Merge the fetched manifestsByRun with the manifests in our abnormality
    mergeFetchedManifestsWithManifestsInAbnormality = (fetchedManifests, abnormalityManifests) => {
        const clonedFetchedManifests = cloneDeep(fetchedManifests);
        const toProcessAbnormalityManifests = cloneDeep(abnormalityManifests);

        let manifests = map(clonedFetchedManifests, man => {
            const matchingAbnormalityManifest = find(toProcessAbnormalityManifests, [
                'manifest.manifestId',
                man.manifest.manifestId,
            ]);
            if (matchingAbnormalityManifest !== undefined) {
                let { kanbans, ...matchingAbnormalityWithoutKanbans } = matchingAbnormalityManifest;
                assign(man, matchingAbnormalityWithoutKanbans);
                map(man.kanbans, kanban => {
                    let matchingKanban = kanbans.find(k => k.kanbanId === kanban.kanbanId);
                    if (matchingKanban) {
                        kanban.impactedBoxes = matchingKanban.impactedBoxes;
                    }
                    return kanban;
                });
                remove(toProcessAbnormalityManifests, [
                    'manifest.manifestId',
                    man.manifest.manifestId,
                ]);
            }
            return man;
        });

        // If there are unprocessed manifests left, they do not belong to the original run manifests
        // and should be concatenated with manifests
        if (toProcessAbnormalityManifests.length > 0) {
            manifests = concat(manifests, toProcessAbnormalityManifests);
        }

        return orderBy(manifests, ['manifest.manifestNumber', 'asc']);
    };

    // TODO: clean this up after v1.0, belongs in a redux duck
    getRunsForManifest = id => {
        get(`/api/abnormalities/generic/runs/manifest-based/${id}`).then(
            response => {
                this.setState(
                    {
                        data: {
                            ...this.state.data,
                            manifestRoutes: orderBy(response.runs, ['routeCode'], ['asc']),
                        },
                    },
                    () => {
                        const { data } = this.state;
                        if (!!data.manifestRoutes[0]) {
                            this.props
                                .loadRunForGeneric(data.manifestRoutes[0].runId)
                                .then(action => {
                                    this.setState({
                                        data: {
                                            ...data,
                                            run: action.run,
                                        },
                                    });
                                });
                        }
                    }
                );
            },
            error => toastr.error('Could not fetch runs for this manifest...')
        );
    };

    handleRecoveryActionClick = recoveryAction => {
        this.props.router.push(
            `/${this.props.manifestBased ? 'manifests' : 'runs'}/${this.props.id}/abnormality/${
                this.props.abnormalityType
            }/${this.props.abnormalityId}/recoveryAction/${recoveryAction.recoveryActionType}/${
                recoveryAction.recoveryActionId
            }`
        );
    };

handleReasonChangeonInputChange = abnormalityTypeValue => {
       console.log("abnormalityTypeValue : "+abnormalityTypeValue);
        this.setState({
            selectedReason:I18N.FORMS.SELECT_REASON,
         });
        
            if(abnormalityTypeValue === ABNORMALITIES.DAMAGE)
            {
                console.log(this.state.reason);
                this.setState({
                   reason:genericDamageReasons,
                   isReasonToShow : true,
                });
            }
            else if(abnormalityTypeValue === ABNORMALITIES.EARLY_FREIGHT){
                this.setState({
                    reason:genericEarlyFreightReasons,
                    isReasonToShow : true,
                 });
            }
            else if(abnormalityTypeValue === ABNORMALITIES.LATE_FREIGHT){
                this.setState({
                    reason:genericLateFreightReasons,
                    isReasonToShow : true,
                 });
            }
            else if(abnormalityTypeValue === ABNORMALITIES.INTERNAL_LOGISTICS){
                this.setState({
                    reason:genericInternalLogisticsReasons,
                    isReasonToShow : true,
                 });
            }
            else if(abnormalityTypeValue === ABNORMALITIES.UNABLE_TO_LOCATE){
                this.setState({
                    reason:genericUnableToLocateReasons,
                    isReasonToShow : true,
                 });
            }
            else{
                this.setState({
                    reason:[],
                    isReasonToShow : false,
                 });
            }
        
    };


    handleInputChange = e => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value,
            },
        });
		if(e.target.name === "abnormalityType")
        {
            this.handleReasonChangeonInputChange(e.target.value);
        }
    };

    handleDateChange = name => date => {
        this.setState({
            form: {
                ...this.state.form,
                [name]: date,
            },
        });
    };

    // TODO: improve after v1.0, find a way to automatically get the run via props
    // instead of setting it manually...
    handleRouteChange = e => {
        this.setState({ selectedRoute: e.target.value });
        if (!e.target.value === '') {
            this.props.loadRunForGeneric(e.target.value).then(action =>
                this.setState({
                    data: { ...this.state.data, run: action.run },
                })
            );
        }
    };

    handleSingleKanbanSelection = (kanbanRow, selectKanban) => {
        let selectedKanbanIds = [...this.state.selectedKanbanIds];

        if (selectKanban) {
            if (!includes(selectedKanbanIds, kanbanRow.kanbanId)) {
                selectedKanbanIds.push(kanbanRow.kanbanId);
            }
        } else {
            selectedKanbanIds = pull(selectedKanbanIds, kanbanRow.kanbanId);
        }

        this.setState({ selectedKanbanIds });
    };

    handleAllKanbansSelection = (selectAllKanbans, kanbanRows) => {
        let selectedKanbanIds = [...this.state.selectedKanbanIds];

        if (selectAllKanbans) {
            selectedKanbanIds = union(selectedKanbanIds, map(kanbanRows, k => k.kanbanId));
        } else {
            selectedKanbanIds = pullAll(selectedKanbanIds, map(kanbanRows, k => k.kanbanId));
        }

        this.setState({ selectedKanbanIds });
    };

    handleSingleManifestSelection = (abnManifestRow, isSelected) => {
        let selectedManifestIds = [...this.state.selectedManifestIds];
        let selectedKanbanIds = [...this.state.selectedKanbanIds];
        const kanbanIds = map(abnManifestRow.kanbans, k => k.kanbanId);

        if (isSelected) {
            // Select
            selectedManifestIds = union(selectedManifestIds, [abnManifestRow.manifest.manifestId]);
            selectedKanbanIds = union(selectedKanbanIds, kanbanIds);
        } else {
            // Deselect
            selectedManifestIds = pull(selectedManifestIds, abnManifestRow.manifest.manifestId);
            selectedKanbanIds = pullAll(selectedKanbanIds, kanbanIds);
            this.resetManifest(abnManifestRow);
        }

        this.clearManifestErrors();
        this.setState({ selectedManifestIds, selectedKanbanIds });
    };

    handleAllManifestsSelection = (selectAll, abnManifestRows) => {
        let selectedManifestIds = [...this.state.selectedManifestIds];
        let selectedKanbanIds = [...this.state.selectedKanbanIds];

        if (selectAll) {
            // Select all
            abnManifestRows.forEach(am => {
                selectedManifestIds.push(am.manifest.manifestId);
                selectedKanbanIds = union(selectedKanbanIds, map(am.kanbans, k => k.kanbanId));
            });
        } else {
            // Deselect all
            selectedManifestIds = [];
            selectedKanbanIds = [];
            abnManifestRows.forEach(am => this.resetManifest(am));
        }

        this.clearManifestErrors();
        this.setState({ selectedManifestIds, selectedKanbanIds });
    };

    handleManifestEdit = (manifestRow, cellName, cellValue) => {
        if (this.props.hasError) {
            this.props.clearErrorMessage();
        }
        const { data } = this.state;
        const abnManifests = cloneDeep(data.abnManifests);
        const abnManifest = { ...manifestRow };

        if (!isNaN(cellValue) && !isNaN(parseInt(cellValue, 10))) {
            abnManifest[cellName] = parseInt(cellValue, 10);
        } else {
            abnManifest[cellName] = cellValue;
        }

        const index = findIndex(abnManifests, [
            'manifest.manifestId',
            manifestRow.manifest.manifestId,
        ]);
        abnManifests.splice(index, 1, abnManifest);

        this.setState({
            data: { ...data, abnManifests },
        });
    };

    handleKanbanEdit = abnManifestRow => (kanbanRow, cellName, cellValue) => {
        const abnManifests = cloneDeep(this.state.data.abnManifests);
        const anbManifest = { ...abnManifestRow };
        const kanban = {
            ...find(anbManifest.kanbans, ['kanbanId', kanbanRow.kanbanId]),
        };

        if (!isNaN(cellValue) && !isNaN(parseInt(cellValue, 10))) {
            kanban[cellName] = parseInt(cellValue, 10);
        } else {
            kanban[cellName] = cellValue;
        }

        const kanbanIndex = findIndex(anbManifest.kanbans, {
            kanbanId: kanban.kanbanId,
        });
        anbManifest.kanbans.splice(kanbanIndex, 1, kanban);

        const index = findIndex(abnManifests, [
            'manifest.manifestId',
            abnManifestRow.manifest.manifestId,
        ]);
        abnManifests.splice(index, 1, anbManifest);

        this.setState({
            data: { ...this.state.data, abnManifests },
        });
    };

    handleCreateAbnormality = () => {
        const { id } = this.props;
                       const { data, form, selectedManifestIds, selectedRoute, manifestBased, selectedReason } = this.state;
                       const abnManifests = cloneDeep(data.abnManifests);
                       const { receivedRun, ...postData } = form;
                       var errors;
                       if(!manifestBased){
                       errors = handleGenericValidations(form, selectedManifestIds, "NA", selectedReason, this.state.isReasonToShow);
                       }else{
                       errors = handleGenericValidations(form, selectedManifestIds, selectedRoute, selectedReason, this.state.isReasonToShow);
                       }
        this.setState({ errors });

        if (isEmpty(errors)) {
            postData.abnormalityDate = moment(postData.abnormalityDate);
            postData.manifests = filter(abnManifests, am =>
                includes(selectedManifestIds, am.manifest.manifestId)
            );
            postData.manifests = this.prepareManifestsForPost(postData.manifests);
            if (manifestBased) {
                postData.runId = selectedRoute;
            } else {
                postData.runId = id;
            }
            if (
                receivedRun &&
                receivedRun.runId &&
                abnormalityTypeCanHaveReceivedRun(postData.abnormalityType)
            ) {
                postData.receivedRunId = receivedRun.runId;
            }
			postData.reason = selectedReason;
            console.log('[Generic] Post data (create)', postData);

            this.setState({ postData });
            this.handleCreateAbnormalityModal('createAbnormality');
        }
    };

    handleUpdateAbnormality = () => {
        const { abnormality } = this.props;
        const { data, form, selectedManifestIds, manifestBased, selectedReason } = this.state;
        const abnManifests = cloneDeep(data.abnManifests);
        const { receivedRun, runId, ...postData } = form;

        let {
        selectedRoute,
        }= this.state;

        if (abnormality && selectedRoute===''){
            selectedRoute=' ';
        }

        const errors = handleGenericValidations(form, selectedManifestIds, selectedRoute, selectedReason, this.state.isReasonToShow);
        this.setState({ errors });

        if (isEmpty(errors)) {
            const abnormalityDate = moment(form.abnormalityDate);
            if (!abnormalityDate.isSame(abnormality.abnormalityDate)) {
                postData.abnormalityDate = abnormalityDate;
            }

            if (form.abnormalityType !== abnormality.abnormalityType) {
                postData.abnormalityType = form.abnormalityType;
            }

            if (
                form.abnormalityLocation !== I18N.ABNORMALITY_LOCATION.OTHER ||
                (abnormality.stop && form.abnormalityLocation !== abnormality.stop.stopCode)
            ) {
                postData.abnormalityLocation = form.abnormalityLocation;
            }

            if (form.comment !== abnormality.comment) {
                postData.comment = form.comment;
            }

            if (form.receivedRunId !== abnormality.receivedRunId) {
                postData.receivedRunId = form.receivedRunId;
            }

            if (form.trailerIdentifier !== abnormality.trailerIdentifier) {
                postData.trailerIdentifier = form.trailerIdentifier;
            }

            if (manifestBased) {
                if (selectedRoute === '') {
                    postData.runId = null;
                } else {
                    postData.runId = selectedRoute;
                }
            }

            postData.manifests = filter(abnManifests, am =>
                includes(selectedManifestIds, am.manifest.manifestId)
            );
            postData.manifests = this.prepareManifestsForPost(postData.manifests);
            postData.abnormalityId = this.props.abnormality.abnormalityId;

            if (receivedRun) {
                if (receivedRun.runId) {
                    postData.receivedRunId = receivedRun.runId;
                } else if (data.receivedRun && data.receivedRun.runId) {
                    postData.receivedRunId = null;
                }
            }
			postData.reason = selectedReason;
            console.log('[Generic] Post data (update)', postData);

            this.setState({ postData });
            this.handleUpdateAbnormalityModal('updateAbnormality');
        }
    };

    prepareManifestsForPost = abnManifests => {
        const { selectedKanbanIds } = this.state;
        const manifests = [];

        abnManifests.forEach(am => {
            const kanbans = filter(am.kanbans, k => includes(selectedKanbanIds, k.kanbanId));
            console.log('[Generic] Included kanbans', kanbans);
            const manifest = {};
            manifest.kanbans = kanbans;
            manifest.manifestId = am.manifest.manifestId;
            manifest.numberOfPallets = am.numberOfPallets;
            manifests.push(manifest);
        });
        console.log('[Generic] Resulting manifests to be posted', manifests);
        return manifests;
    };

    resetManifest = abnMan => {
        // When deselecting a manifest for example, reset it to its original values
        const abnManifests = cloneDeep(this.state.data.abnManifests);
        const abnManifest = { ...abnMan };
        const index = findIndex(abnManifests, ['manifest.manifestId', abnMan.manifest.manifestId]);

        abnManifest.numberOfPallets = '';
        abnManifest.kanbans.forEach(k => (k.impactedBoxes = ''));

        abnManifests.splice(index, 1, abnManifest);

        this.setState({
            data: { ...this.state.data, abnManifests },
        });
    };

    clearManifestErrors = () => {
        if (this.props.hasError) {
            this.props.clearErrorMessage();
        }
        if (this.state.errors.abnManifests) {
            this.setState({ errors: omit(this.state.errors, 'abnManifests') });
        }
        if (this.state.errors.pallets) {
            this.setState({ errors: omit(this.state.errors, 'pallets') });
        }
    };

    // -------------------- confirmation modal -------------------- //

    handleCreateAbnormalityModal = () => {
        this.setState({
            modalData: {
                showModal: true,
                title: 'Create abnormality',
                message: 'Are you sure you want to create this abnormality?',
                mode: 'createAbnormality',
            },
        });
    };

    handleUpdateAbnormalityModal = () => {
        this.setState({
            modalData: {
                showModal: true,
                title: 'Update abnormality',
                message: 'Are you sure you want to update this abnormality with these changes?',
                mode: 'updateAbnormality',
            },
        });
    };

    handleCancelAbnormalityModal = () => {
        this.setState({
            modalData: {
                showModal: true,
                title: 'Cancel abnormality',
                message: 'Are you sure you want to cancel this abnormality?',
                mode: 'cancelAbnormality',
            },
        });
    };

    handleCloseAbnormalityModal = () => {
        this.setState({
            modalData: {
                showModal: true,
                title: 'Close abnormality',
                message: 'Are you sure you want to close this abnormality?',
                mode: 'closeAbnormality',
            },
        });
    };

    handleCloseModal = () => {
        this.setState({
            modalData: {
                showModal: false,
                title: '',
                message: '',
                mode: '',
            },
        });
    };

    handleConfirmModal = mode => {
        switch (mode) {
            case 'cancelAbnormality':
                this.props.cancelAbnormality({
                    abnormalityId: this.props.abnormalityId,
                });
                this.handleCloseModal();
                window.setTimeout(this.redirect, 1500);
                return;
            case 'closeAbnormality':
                this.props.closeAbnormality({
                    abnormalityId: this.props.abnormalityId,
                });
                this.handleCloseModal();
                window.setTimeout(this.redirect, 1500);
                return;
            case 'updateAbnormality':
                this.props.editAbnormality(this.props.abnormalityType, this.state.postData);
                this.handleCloseModal();
                return;
            case 'createAbnormality':
                this.props.createAbnormality(ABNORMALITIES.GENERIC, this.state.postData);
                this.handleCloseModal();
                this.props.toastr.add({
                    id: 'pendingToast',
                    type: 'info',
                    position: 'top-right',
                    title: 'Creating abnormality...',
                    attention: true,
                    options: toastrOptions,
                });
                return;
            default:
                return;
        }
    };

    handleAssignAbnormalityToMe = id => {
        this.props.assignAbnormalityToMe(id);
    };

    redirectOrRemovePendingToast = doRedirect => {
        if (doRedirect) {
            window.setTimeout(this.redirect, 1800);
        } else {
            this.props.toastr.remove('pendingToast');
        }
    };

    redirect = () => {
        const { id, router } = this.props;
        const { manifestBased } = this.state;
        this.props.toastr.remove('pendingToast');

        if (manifestBased) {
            router.push(`/manifests/${this.getManifestIdFromStateData()}`);
        } else {
            router.push(`/runs/${id}`);
        }
    };

    // -------------------- confirmation modal -------------------- //

    handleReceivedRunChange = run => {
        this.setState(() => ({
            form: {
                ...this.state.form,
                receivedRun: run,
            },
        }));
    };

    handleRemoveReceivedRun = () => {
        this.setState(() => ({
            form: {
                ...this.state.form,
                receivedRun: {
                    runId: null,
                },
            },
        }));
    };

    renderBreadcrumb = (run, abnormality, manifestBased) => {
        if (isEmpty(run)) return '';

        const abnormalityType = this.state.form.abnormalityType;
        if (!!abnormality && abnormality.abnormalityId) {
            return createAbnormalityDetailBreadcrumb({
                run,
                abnormality,
                manifestBased,
            });
        } else {
            return createAbnormalityCreationBreadcrumb({
                run,
                manifest: {
                    manifestId: this.props.id,
                    manifestNumber: this.props.location.query.manifestNumber,
                },
                manifestBased,
                abnormalityType,
            });
        }
    };

    renderAnalysisLink(path) {
        if (path.endsWith('/')) {
            return path + 'genericAbnormalityAnalysis';
        }
        return path + '/genericAbnormalityAnalysis';
    }

    render() {
        const {
            abnormality,
            abnormalityId,
            abnormalityAttachments,
            isFetchingAbnormality,
            isAbnormalityAttachmentsPending,
            isFetchingGenericManifests,
            isFetchingRun,
        } = this.props;
        const {
            form,
            manifestBased,
            errors,
            data: { abnManifests, run, manifestRoutes, stops },
            modalData,
            selectedKanbanIds,
            selectedManifestIds,
            //selectedRoute,
        } = this.state;

        let {
             selectedRoute,
            }= this.state;

        const path = this.props.location.pathname;
        const abnormalityIsEditable =
            !abnormality ||
            (abnormality &&
                (abnormality.abnormalityStatus !== STATUSES.CLOSED &&
                    abnormality.abnormalityStatus !== STATUSES.CANCELLED));

        if (isFetchingAbnormality) {
            return <Loader />;
        }

        if (abnormality && selectedRoute===''){
            selectedRoute=' ';
        }

        return (
            <div>
                {this.renderBreadcrumb(run, abnormality, manifestBased)}

                {run && run.updatedByTlms && <TLMSWarning />}

                <Row>
                    <Col sm={6}>
                        <RouteInfoGeneric
                            handleRouteChange={this.handleRouteChange}
                            errors={errors}
                            isFetching={isFetchingRun}
                            manifestRoutes={manifestRoutes}
                            abnormality={abnormality}
                            routeCode={run && run.routeCode}
                            runDate={run && run.runDate}
                            runSeq={run && run.runSequence}
                            selectedRoute={selectedRoute}
                        />
                    </Col>
                    <AssigneeInfo
                        colSize={6}
                        assignee={abnormality && abnormality.assignee}
                        assigneeGroup={abnormality && abnormality.groupRoleAssignees}
                    />
                </Row>

                <GenericInfo
                    abnormality={abnormality || {}}
                    errors={errors}
                    form={form}
                    handleDateChange={this.handleDateChange}
                    handleInputChange={this.handleInputChange}
                    stops={stops}
                />
				
				{this.state.isReasonToShow &&(
                    <Reasons
                    isCreation={this.isAbnormalityCreation()}
                    isEditable={abnormalityIsEditable}
                    onReasonChange={this.handleReasonChange}
                    reasons={this.state.reason}
                    selectedReason={this.state.selectedReason}
                    validations={errors}
                />
                )}
				
				{/* <Panel collapsible defaultExpanded={false} header="Comments" > */}
                <Panel defaultExpanded={true} header={(form.comment && form.comment !== '') ? "Comments⚠️": "Comments"} >
                    <Comments 
                        comment={form.comment}
                        onCommentChange={this.handleInputChange}
                        showLabel={false}
                    />
                </Panel>

                <ManifestsInfoGeneric
                    abnormality={abnormality}
                    handleCellEdit={this.handleManifestEdit}
                    handleKanbanCellEdit={this.handleKanbanEdit}
                    handleKanbanSelection={this.handleSingleKanbanSelection}
                    handleKanbanSelectionAll={this.handleAllKanbansSelection}
                    handleManifestSelection={this.handleSingleManifestSelection}
                    handleManifestSelectionAll={this.handleAllManifestsSelection}
                    isEditable={abnormalityIsEditable}
                    isSelectable={!manifestBased}
                    isFetching={isFetchingGenericManifests}
                    abnManifests={abnManifests}
                    selectedKanbanIds={selectedKanbanIds}
                    selectedManifestIds={selectedManifestIds}
                    errors={errors}
                />

                <ReceivedRun
                    abnormalityType={form.abnormalityType}
                    errors={errors}
                    receivedRun={form.receivedRun}
                    onChooseReceivedRun={this.handleReceivedRunChange}
                    onRemoveReceivedRun={this.handleRemoveReceivedRun}
                />
                {!this.isAbnormalityCreation() && (
                    <div>
                        <RecoveryActionsInfo
                            recoveryActions={abnormality && abnormality.recoveryActions}
                            onRecoveryActionClick={this.handleRecoveryActionClick}
                            manifestsWereSelected={true}
                            isEditable={abnormalityIsEditable}
                            createLink={this.renderAnalysisLink(path)}
                        />
                        <AttachmentsInfo
                            abnormalityId={abnormalityId}
                            attachments={abnormalityAttachments || []}
                            isPending={isAbnormalityAttachmentsPending}
                        />
                    </div>
                )}
                
              
                <AbnormalityActionButtons
                    abnormality={abnormality}
                    abnormalityType={ABNORMALITIES.GENERIC}
                    handleAssignAbnormalityToMe={this.handleAssignAbnormalityToMe}
                    handleCancelAbnormalityModal={this.handleCancelAbnormalityModal}
                    handleCloseAbnormalityModal={this.handleCloseAbnormalityModal}
                    handleCreateAbnormality={this.handleCreateAbnormality}
                    handleUpdateAbnormality={this.handleUpdateAbnormality}
                    runId={run && run.runId}
                />
                {modalData.showModal && (
                    <ConfirmationModal
                        message={modalData.message}
                        mode={modalData.mode}
                        onClose={this.handleCloseModal}
                        onConfirm={this.handleConfirmModal}
                        showModal={modalData.showModal}
                        title={modalData.title}
                    />
                )}
            </div>
        );
    }
}

Generic = connect(
    (state, ownProps) => ({
        abnormality: getAbnormalityById(state, ownProps.abnormalityId),
        abnormalityAttachments: getAbnormalityAttachments(state, ownProps.abnormalityId),
        hasErrors: getError(state),
        isAbnormalityAttachmentsPending: isAbnormalityAttachmentsPending(state),
        isFetchingAbnormality: getIsFetchingAbnormality(state),
        isFetchingGenericManifests: getIsFetchingGenericManifests(state),
        isFetchingRun: getIsFetchingRun(state),
        isAbnormalityPending: getIsAbnormalityPending(state),
        abnManifests: getGenericManifests(state),
        run: getRunById(state, ownProps.id),
    }),
    dispatch => ({
        assignAbnormalityToMe: bindActionCreators(assignAbnormalityToMe, dispatch),
        cancelAbnormality: bindActionCreators(cancelAbnormality, dispatch),
        clearErrorMessage: bindActionCreators(clearErrorMessage, dispatch),
        closeAbnormality: bindActionCreators(closeAbnormality, dispatch),
        createAbnormality: bindActionCreators(createAbnormality, dispatch),
        editAbnormality: bindActionCreators(editAbnormality, dispatch),
        loadAbnormality: bindActionCreators(loadAbnormality, dispatch),
        loadAbnormalityFiles: bindActionCreators(loadAbnormalityFiles, dispatch),
        loadGenericManifests: bindActionCreators(loadGenericManifests, dispatch),
        loadRunForGeneric: bindActionCreators(loadRunForGeneric, dispatch),
        toastr: bindActionCreators(toastrActions, dispatch),
        updateAbnormality: bindActionCreators(editAbnormality, dispatch),
    })
)(Generic);

Generic = withRouter(Generic);

export default Generic;
